// import Security from '@/_helpers/security.js';

import outer from '@/routes_new/outer';
const old_layout = () => import('@/layout/old_layout.vue');
// import SportMasterOuter from '@/process/sportmaster/routes_new/outer/SportMasterOuter.vue';
// import SportMasterFinish from '@/process/sportmaster/routes_new/outer/interview/finish/SportMasterFinish.vue';

const VcvSettings = () => import('@/routes_new/inner/settings/VcvSettings.vue');
const SettingsAdditionalView = () => import('@/process/_components/settings/SettingsAdditionalView.vue');
// import RatesInformer from '@/routes_new/inner/settings/rates/RatesInformer';
import HeaderView from '@/components/header/Scene';

export default [
  // {
  //   path: '',
  //   component: outer,
  //   children: [
  //     {
  //       path: 'sm',
  //       meta: {
  //         title: 'pageTitles.routes.invitations.new',
  //         is_adaptive: true
  //       },
  //       component: SportMasterOuter,
  //       children: [
  //         {
  //           path: 'interviews/:token/finish',
  //           props: true,
  //           component: SportMasterFinish
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    path: '',
    component: old_layout,
    children: [
      {
        path: '/settings',
        components: {
          default: VcvSettings,
          // rates_informer: RatesInformer,
          header: HeaderView
        },
        props: {
          header: {
            displayNavigation: true
          }
        },
        meta: {
          title: 'pageTitles.routes.settings.root'
        },
        children: [
          {
            path: 'additional',
            name: 'settings-additional',
            component: SettingsAdditionalView,
            meta: {
              title: 'pageTitles.routes.settings.company'
            }
          }
        ]
      }
    ]
  }
];
